import React from 'react';
import { AppProvider } from '../../ApplicationContent/ApplicationContent';
import Header from '../Header/Header';
import Upper from '../Upper/Upper';
import VideoPart from '../VideoPart/VideoPart';
import InfoPart from '../InfoPart/InfoPart';
import Footer from '../Footer/Footer';
import Gallery from '../Gallery/Gallery';

function App() {
  return (
    <div className="App">
        <AppProvider>
          <Header />
          <Upper />
          <VideoPart />
          <InfoPart />
          <Gallery />
          <Footer />
        </AppProvider>
    </div>
  );
}

export default App;
